import { render, staticRenderFns } from "./AffiliatePosts.vue?vue&type=template&id=5cd56b04&scoped=true&"
import script from "./AffiliatePosts.vue?vue&type=script&lang=js&"
export * from "./AffiliatePosts.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatePosts.vue?vue&type=style&index=0&id=5cd56b04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd56b04",
  null
  
)

export default component.exports